interface FranchiseHeroProps {
  label: string
  body: string
  emphasis: string
  imageUrl: string
  imageUrlMobile: string
  imageAlt: string
}

export function FranchiseHero({
  label,
  body,
  emphasis,
  imageUrl,
  imageUrlMobile,
  imageAlt,
}: FranchiseHeroProps) {
  return (
    <section id="hero" data-marketing-section="" className="w-full bg-qb-bg">
      <div className="mx-auto max-w-[1136px] px-5 lg:px-10 pt-10 lg:pt-20">
        <div className="flex flex-col items-center text-center gap-4 lg:gap-6 tracking-[-0.6px]">
          <p className="font-bold text-qb-primary text-[16px] lg:text-[24px] leading-[1.5] lg:leading-[1.4]">
            {label}
          </p>
          <p className="font-medium text-qb-text-high text-[20px] lg:text-[36px] leading-[1.5] lg:leading-[1.4] whitespace-pre-line">
            {body}
          </p>
          <h1 className="font-bold lg:font-extrabold text-qb-text-high text-[32px] lg:text-[56px] leading-[1.4] lg:leading-[1.2] whitespace-pre-line lg:whitespace-normal">
            {emphasis}
          </h1>
        </div>
      </div>
      <div className="mt-14 lg:mt-20 w-full overflow-hidden">
        <picture>
          <source media="(min-width: 1024px)" srcSet={imageUrl} />
          <img
            src={imageUrlMobile}
            alt={imageAlt}
            className="w-full object-cover h-[280px] lg:h-[440px]"
          />
        </picture>
      </div>
    </section>
  )
}
